<template>
    <MasterWorkSheet></MasterWorkSheet>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MasterWorkSheet = defineAsyncComponent(() =>
    import("../../components/CNC/MasterWorkSheet.vue")
);

export default {
    name: "CNCMasterWorkSheet", //The name you are in should not equal the name of the component you are importing.
    components: { MasterWorkSheet, AuthLayout },
};
</script>
